import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { OverlayPanel } from 'primereact/overlaypanel';
import { StockServices } from "../services/stockServices";
import { CalculationServices } from "../services/calculationsServices";
import { shipmentServices } from "../services/shipmentServices";
import Stocks from './stocks/product';
import { Dialog } from 'primereact/dialog';
import {Barchart} from '../components/chartComponent';
import {useAnalytics} from '../contexts/AnalyticsContext';
import {OutOfStockBadge} from '../components/badges';



const data = [
  ["Stock Type", "Quantity"],
  ["Finished Stock", 15000],
  ["In Process Stock", 30000],
  ["Slow Moving Stock", 3000],
  ["Dead Stock", 500],
  ["Excess Stock", 1000],
  ["Stock in Transit", 5000],
];

const options = {
  pieHole: 0.6,
  legend: "none",
  pieSliceText: "none",
  chartArea: { width: "100%", height: "100%" },
  colors: [
    "#FFCC99", // Finished Stock
    "#CCE5FF", // In Process Stock
    "#E6E6B3", // Slow Moving Stock
    "#B3C6FF", // Dead Stock
    "#D9B3FF", // Excess Stock
    "#996666", // Stock in Transit
  ],
  backgroundColor: "transparent",
};

const linechartdata = [
  ["Month", "Forecast A", "Forecast B"],
  ["Jan", 100, 90],
  ["Feb", 120, 110],
  ["Mar", 130, 125],
  ["Apr", 125, 130],
  ["May", 140, 135],
  ["Jun", 160, 150],
  ["Jul", 155, 140],
  ["Aug", 170, 130],
];

const linechartoptions = {
  legend: "none",
  curveType: "function", // smooth curves
  chartArea: { width: "100%", height: "100%" },
  backgroundColor: "transparent",
  hAxis: { title: "Month",
            // slantedText: true,       // ✅ makes month labels visible and angled
            slantedTextAngle: 45,  },
  vAxis: { textPosition: "none", baselineColor: "transparent", gridlines: { color: "transparent" } },
  lineWidth: 3,
  series: {
    0: {
      color: "#3B82F6", // Blue
      areaOpacity: 0.15,
    },
    1: {
      color: "#FB923C", // Orange
      areaOpacity: 0.1,
    },
  },
};



const productdata = [
  ["Product", "Sales"],
  ["CBD Tanning Water", 40],
  ["Utan Pen", 30],
  ["Utan Sculptor Fullset", 30],
];

const productoptions = {
  pieHole: 0.6,
  legend: "none",
  pieSliceText: "none",
  chartArea: { width: "100%", height: "100%" },
  colors: ["#3B82F6", "#A78BFA", "#FBBF24", "#7C3AED", "#7F1D1D"], // blue, purple, yellow, extra
  backgroundColor: "transparent",
};

const Dashboard = () => {

  const [stockdialog, setStockdialog] = useState(false);
  const [stockdata, setStockdata] = useState([]);
  const [stockdatamulti, setStockdatamulti] = useState({});
  const [stocktypeheader, setStocktypeheader] = useState('');
  const [calculations, setCalculations] = useState({});
  const [productbulkdata, setProductBulkData] = useState([]);
  const [productTotal, setProductTotal] = useState('');
  const [productName, setProductName] = useState([]);
  const [salesRevenue, setSalesRevenue] = useState([]);
  const [expensesSales, setExpensesSales] = useState([]);
  const {getAnalyticsdata,analyticsData} = useAnalytics();
  
  useEffect(()=>{
    // getStockdata('all'); 
    getStockdatadashboard('all'); 
    getProductDashboardData();
    Graphdataresult();
    getAnalyticsdata();
    CalculationServices.getCalculations().then((response)=>{
      // console.log("response data");  
      // console.log(response);
      if(response.status == 200){
          setCalculations(response.data.data);    
      }else{
          setCalculations([]); 
      }
    }).catch((error)=>{

    })
  },[])

  const getStockdatadashboard = (stocktype) => {
    StockServices.getstock(stocktype).then((response) => {
      if (response.status == 200) {
        // console.log(response.data.datacount.expired);
        setStockdatamulti(response.data.datacount);
      } else {
        setStockdatamulti([]);
      }
    }).catch((error) => {
      setStockdatamulti([]);
      // console.log(error);
    });
  }

  const getProductDashboardData = () => {
    StockServices.getbulkproduct(1,10).then((response) => {
      if(response.status == 200){
        console.log("The product bulk data : ", response.data.data);
        setProductBulkData(response.data.data);

        let totalProductData = response.data.data;
        calculateTotalProductSales(totalProductData);
      }else{
        setProductBulkData([]);
      }
    }).catch((error) => {
      setProductBulkData([]);
    })
  }

  
  const calculateTotalProductSales = (data) => {
      console.log("Result data : ", data);
       let productData = [["Product", "Sales"]];
          data.forEach(element => {
            if(Number(element.totalunit_sold) > 0){
              productData.push([element.product_name, Number(element.totalunit_sold)]);
            }
          })
          console.log("product name data : ", productData);
          setProductName(productData);
  }

  const ShowLegendData = () => {
      console.log("Product bulk data :", productbulkdata);
      const colors = ["#3B82F6", "#A78BFA", "#FBBF24", "#7C3AED", "#7F1D1D" ]
      return (<div>
          {
            productbulkdata?.map((element, index) =>{
              if(Number(element.totalunit_sold) > 0){
                return (<Legend key={index} color={colors[index % colors.length]} label={element.product_name} />)
              }
            })
          }
        </div>)
  }

  const getStockdata = (stocktype) => {
    StockServices.getstock(stocktype).then((response) => {
      if (response.status == 200) {
        setStockdata(response.data.data);
      } else {
        setStockdata([]);
      }
    }).catch((error) => {
      setStockdata([]);
      console.log(error);
    });
  }

  const displayStock = () =>{
     let component = [];
     stockdata.forEach((value,index)=>{
          component.push(
          (<tr className={index % 2 === 0 ? 'eventr' : 'oddtr'}>
            <td>{value.product_name}</td>
            <td>{value.product}</td>
            <td>{value.batch_number}</td>
            <td>{value.quantity} ({value.unit_of_measurement})</td>
            <td>{value.stock_date}</td>
            <td>{value.stocktype}</td>
          </tr>));  
     });

    let table1 = (<table className='table table-bordered'>
         <tr>
             <th>Product Name</th>
             <th>Product</th>
             <th>Batch No</th>
             <th>Quantity In Stock</th>
             <th>Stock Date</th>
             <th>Stock Type</th>
         </tr>
         {component}
     </table>) 
     
     let obj = {
        'stock_data': table1 
     } 

     return obj;
  }

//   const citydata = [
//   ["Month", "Profit"],
//   ["Jan", 820000],
//   ["Feb", 760000],
//   ["Mar", 900000],
//   ["Apr", 870000],
//   ["May", 950000],
//   ["Jun", 880000],
//   ["Jul", 920000],
//   ["Aug", 890000],
//   ["Sep", 940000],
//   ["Oct", 970000],
//   ["Nov", 910000],
//   ["Dec", 960000],
// ];

const Graphdataresult = () =>{
   StockServices.Graphdataresult().then((response) => {
      console.log(response,'response data'); 
      if (response.status == 200) {
            setSalesRevenue(response.data.data);
            setExpensesSales(response.data.expensesRevenue);
            
        // setStockdata(response.data.data);
      } else {
        // setStockdata([]);
          setSalesRevenue([]);
          setExpensesSales([]);
      }
    }).catch((error) => {
       setSalesRevenue([]);
       setExpensesSales([]);
      // setStockdata([]);
      // console.log(error);
    });
}


  return (

    <>
      <h4 className="mb-4 fw-bold text-dark">Dashboard</h4>
      <div className="row g-4">

        {/* Approved PO */}
        <div className="col-md-4">
          <div className="card shadow-sm p-3 rounded-4">
            <div className="d-flex align-items-center">
              <div className="me-3 fs-4 circle-icon bg-success text-white rounded-circle d-flex justify-content-center align-items-center" style={{ width: 40, height: 40 }}>
                <i className="fas fa-check"></i>
              </div>
              <div>
                <div className="text-muted small">Approved PO</div>
                <h4 className="m-0 fw-bold">{calculations?.approvedpo}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* Pending Approvals */}
        <div className="col-md-4">
          <div className="card shadow-sm p-3 rounded-4">
            <div className="d-flex align-items-center">
              <div className="me-3 fs-4 circle-icon bg-warning text-white rounded-circle d-flex justify-content-center align-items-center" style={{ width: 40, height: 40 }}>
                <i className="fas fa-spinner"></i>
              </div>
              <div>
                <div className="text-muted small">Pending Approvals</div>
                <h4 className="m-0 fw-bold">{calculations?.notapprovedpo}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* Forecast */}
        <div className="col-md-4">
          <div className="card shadow-sm p-3 text-center text-white rounded-4" style={{ backgroundColor: '#752C3D' }}>
            <h5 className="fw-bold mt-2">Forecast</h5>
          </div>
        </div>

        {/* Stock Alerts */}
        <div className="col-md-4 mt-0 mb-0">
          <div className="card shadow-sm p-3 rounded-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold">Stock Alerts</h6>
              <a href="/" className="text-decoration-none">View all</a>
            </div>
            <ul className="list-unstyled mb-0">
              {["Low Stock", "Low Stock", "Low Stock"].map((status, index) => (
                <li key={index} className="mb-3 d-flex align-items-center">
                  <div>
                    Freckle Fluid <br />
                    <span className="fw-bold">2500 ml</span>
                  </div>
                  <span className={`badge ms-auto ${index === 2 ? 'bg-warning text-white' : 'bg-light text-danger'}`}>
                    {status}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Total Stock and Breakdown */}
        <div className="col-md-8 mt-0 mb-0">
          <div className="card shadow-sm p-4 rounded-4">
            <div className="row align-items-center">
              {/* Donut Chart */}
              <div className="col-md-5 d-flex justify-content-center">
                <div style={{ width: 250, height: 200, position: "relative" }}>
                  <Chart
                    chartType="PieChart"
                    data={data}
                    options={options}
                    width="100%"
                    height="100%"
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    <div>Total Stock</div>
                    <div style={{ fontSize: "20px" }}>63,000</div>
                  </div>
                </div>
              </div>

              {/* Custom Legend */}
              <div className="col-md-7">
                <div className="row">
                  <div className="col-6 mb-3">
                    {/* <LegendItem color="#FFCC99" label="Finished Stock" value="15000" /> */}
                    <LegendItem color="#FFCC99" label="Finished Stock" classdata="clickable" value={stockdatamulti?.available} fun={(e) => { setStockdialog(true); getStockdata('available'); setStocktypeheader('Finished Stock') }} />
                  </div>
                  <div className="col-6 mb-3">
                    <LegendItem color="#CCE5FF" label="Out of Stock"  />
                    <OutOfStockBadge value={analyticsData?.data?.data?.outofstock} refreshFun={() => getAnalyticsdata()}  viewdata={analyticsData?.data?.data?.outofstock_data}
                      isloading={analyticsData?.isloading}/>
                      
                  </div>
                  <div className="col-6 mb-3">
                    <LegendItem color="#CCE5FF" label="In Process Stock" value="30000" />
                  </div>
                  <div className="col-6 mb-3">
                    <LegendItem color="#E6E6B3" label="Slow Moving Stock" value="3000" />
                  </div>
                  <div className="col-6 mb-3">
                    <LegendItem color="#B3C6FF" label="Dead Stock" value={stockdatamulti?.expired} />
                  </div>
                  <div className="col-6 mb-3">
                    <LegendItem color="#D9B3FF" label="Excess Stock" value="1000" />
                  </div>
                  <div className="col-6 mb-3">
                    <LegendItem color="#996666" label="Stock in Transit" value="5000" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        

        {/* <div className="col-md-6 mt-0">
          <div className="card shadow-sm p-4 rounded-4" style={{ backgroundColor: "#ffffff" }}>
            <h6 className="fw-bold text-dark mb-3">Sales Revenue</h6>
            <div style={{ width: "100%", height: "270" }}>
              <Barchart data={salesRevenue}/> 
              
            </div>
          </div>
        </div> */}

        {/* <div className="col-md-6 mt-0">
          <div className="card shadow-sm p-4 rounded-4" style={{ backgroundColor: "#ffffff" }}>
            <h6 className="fw-bold text-dark mb-3">Sales & Expenses</h6>
            <div style={{ width: "100%", height: "270" }}>
              <Barchart data={expensesSales}/> 
             
            </div>
          </div>
        </div> */}
        <div className="col-md-12 mt-0">
          <Stocks dashboard={true} />
        </div>

        {/* <div className="col-md-4 mt-0">
          <div
            className="card shadow-sm p-3 rounded-4"
            style={{ border: "none" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold m-0">Products</h6>
              <span className="text-muted small"><a href="#">This Week ▾</a></span>
            </div>

            <div className="mb-3">
              <Legend color="#3B82F6" label="CBD Tanning Water" />
              <Legend color="#A78BFA" label="Utan Pen" />
              <Legend color="#FBBF24" label="Utan Sculptor Fullset" />
            </div>

           
            <div style={{ width: "100%", height: "100" }}>
              <Chart
                chartType="PieChart"
                data={productdata}
                options={productoptions}
                width="100%"
                height="100%"
              />
            </div>


          </div>



        </div> */}

        {/* <div className="col-md-4 mt-0">
          <div
            className="card shadow-sm p-3 rounded-4"
            style={{ border: "none" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold m-0">Products sold this month</h6>
            
            </div>

        
            <div className="flex-box">
                <div className="mb-3">
                
                <ShowLegendData />
              </div>

          
              <div style={{ width: "100%"}}>
                <Chart
                  chartType="PieChart"
                  data={productName}
                  options={productoptions}
                  width="100%"
                  height="100%"
                />
              </div>
           </div>
          </div>
        </div> */}

        {/* <div className="col-md-8">
          <div className="card shadow-sm p-4 rounded-4" >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">In Transit Items</h6>
              <a href="#!" className="text-primary text-decoration-none">View all</a>
            </div>
            <div className="row fw-bold border-bottom pb-2">
              <div className="col">Component</div>
              <div className="col">Supplier</div>
              <div className="col">Expected delivery</div>
            </div>
            <div className="row pt-2">
              <div className="col">Erythulose</div>
              <div className="col">WePack</div>
              <div className="col">19/05/25</div>
            </div>
            <div className="row pt-2">
              <div className="col">Bottle</div>
              <div className="col">WePack</div>
              <div className="col">19/05/25</div>
            </div>
            <div className="row pt-2 text-danger">
              <div className="col">Overcap</div>
              <div className="col">Viola</div>
              <div className="col">12/05/25</div>
            </div>
          </div>
        </div> */}

        {/* <div className="col-md-4">
          <div className="card shadow-sm p-4 rounded-4" >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Shipment Status</h6>
              <span className="text-muted small">This Week ▼</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span className="text-success">Dispatch</span>
              <span className="fw-bold text-success">2000</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span className="text-warning">In Transit</span>
              <span className="fw-bold text-warning">1500</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span className="text-danger">Delayed</span>
              <span className="fw-bold text-danger">80</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Air</span>
              <span className="fw-bold">80</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Sea</span>
              <span className="fw-bold">2500</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Rail</span>
              <span className="fw-bold">1000</span>
            </div>
          </div>
        </div> */}
      </div>

      <>
        <Dialog header={`${stocktypeheader}`} visible={stockdialog} style={{ width: '70vw' }} onHide={() => {if (!stockdialog) return; setStockdialog(false); }}>
            <div className='container'>
                {displayStock().stock_data}    
            </div>  
        </Dialog>           
      </>               
    </>

  );

  function LegendItem({ color, label, value, fun, classdata, op }) {


    return (
      <div className={`d-flex align-items-center ${classdata}`}>
        <OverlayPanel ref={op}>
          <img src={'https://primefaces.org/cdn/primereact/images/product/bamboo-watch.jpg'} alt="Bamboo Watch"></img>
        </OverlayPanel>
        <div
          className="me-2 rounded"
          style={{ width: "14px", height: "14px", backgroundColor: color }}
        ></div>
        <div>
          <div className="fw-semibold text-dark">{label}</div>
          <div className="text-muted small">{value}</div>
        </div>
      </div>
    );
  }

};

export default Dashboard;

// Legend item component
function Legend({ color, label }) {
  return (
    <div className="d-flex align-items-center mb-1">
      <span
        className="me-2 rounded-circle d-inline-block"
        style={{
          backgroundColor: color,
          width: "10px",
          height: "10px",
        }}
      ></span>
      <span className="text-muted small">{label}</span>
    </div>
  );
}